import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import SitesControl from "./pages";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { centralSitesTheme } from "./theme/main";

const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;

if (TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (TRACKING_ID) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={centralSitesTheme}>
        <CssBaseline />
        <BrowserRouter>
          <AnalyticsTracker />
          <SitesControl />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
